module.exports = __webpack_public_path__ + "static/media/footerdots.e5de92e4.png";